/*
  ZUHOGAR · Compra rápida sobre el carrito de Horizon.
  - zhCart.add(items): agrega al carrito, avisa al tema (evento cart:update) y abre el carrito lateral.
  - Caja de ofertas de la ficha (data-mk-offers): cantidad elegida + complementos marcados.
  - Botones de compra repetidos (data-mks-cta) y sugeridos del carrito (data-mk-rec-*).
*/
(function () {
  if (window.zhCart) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function json(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw d;
        return d;
      });
    });
  }

  function notify(cart) {
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = { resource: cart, sourceId: 'zh-cart', data: { itemCount: cart.item_count, source: 'zh-cart' } };
    document.dispatchEvent(ev);
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') d.open();
    else window.location.href = root + 'cart';
  }

  function refresh(open) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        notify(cart);
        if (open) openDrawer();
        return cart;
      });
  }

  function add(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return json('cart/add.js', { items: items })
      .then(function () { return refresh(true); })
      .catch(function (d) {
        var m = (d && (d.description || d.message)) || 'No se pudo agregar el producto.';
        var full = /m[aá]xima|maximum|only|solo/i.test(m);
        if (full) m = 'Ya tienes en tu carrito todas las unidades disponibles de este color. Revisa tu carrito o elige otro color.';
        if (full) refresh(true);
        var box = btn && btn.closest('[data-mk-offers]'), note = box && box.querySelector('[data-mk-msg]');
        if (!note && box) { note = document.createElement('p'); note.className = 'mk-offers__msg'; note.setAttribute('data-mk-msg', ''); note.setAttribute('role', 'alert'); btn.insertAdjacentElement('afterend', note); }
        if (note) { note.textContent = m; note.hidden = false; } else window.alert(m);
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  window.zhCart = { add: add, refresh: refresh, open: openDrawer };

  /* Formato de precio igual al de la tienda */
  function money(c) {
    var fmt = window.zhMoneyFormat || '${{amount_no_decimals_with_comma_separator}}';
    c = Math.round(c);
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), type = m ? m[1] : 'amount';
    function f(n, d, ts, ds) { var s = (n / 100).toFixed(d).split('.'); return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (s[1] ? ds + s[1] : ''); }
    var map = { amount: f(c, 2, ',', '.'), amount_no_decimals: f(c, 0, ',', '.'), amount_with_comma_separator: f(c, 2, '.', ','), amount_no_decimals_with_comma_separator: f(c, 0, '.', ','), amount_with_apostrophe_separator: f(c, 2, "'", '.') };
    var v = map[type] || f(c, 2, ',', '.');
    if (window.zhHideZeros) v = v.replace(/[.,]00$/, '');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- Caja de ofertas ---------- */
  function initOffers(box) {
    if (box.__zh) return; box.__zh = true;
    var price = +box.dataset.price;
    var offers = box.querySelectorAll('[data-mk-offer]');
    function render() {
      var selTotal = 0;
      offers.forEach(function (o) {
        var q = +o.dataset.qty, d = +o.dataset.discount, full = price * q;
        var ps = o.querySelectorAll('[data-mk-pick]');
        if (ps.length) { full = 0; ps.forEach(function (sel) { var op = sel.options[sel.selectedIndex]; full += +(op && op.dataset.price) || price; }); }
        var total = full * (100 - d) / 100;
        var t = o.querySelector('[data-mk-total]'), fu = o.querySelector('[data-mk-full]'), u = o.querySelector('[data-mk-unit]');
        if (t) t.textContent = money(total);
        if (fu) fu.textContent = money(full);
        if (u) u.textContent = money(total / q);
        if (o.classList.contains('is-selected')) selTotal = total;
      });
      var extras = 0;
      document.querySelectorAll('[data-mk-add].is-on').forEach(function (x) { extras += +x.dataset.price || 0; });
      var cp = box.querySelector('[data-mk-cta-price]');
      if (cp) cp.textContent = money(selTotal + extras);
    }
    offers.forEach(function (o) {
      var input = o.querySelector('input');
      if (input) input.addEventListener('change', function () {
        offers.forEach(function (x) { x.classList.toggle('is-selected', x === o); });
        render();
      });
    });
    var cta = box.querySelector('[data-mk-cta]');
    if (cta) cta.addEventListener('click', function (e) {
      e.preventDefault();
      var sel = box.querySelector('[data-mk-offer].is-selected');
      var qty = sel ? +sel.dataset.qty : 1;
      var items = [{ id: +box.dataset.variant, quantity: qty }];
      var picks = sel ? sel.querySelectorAll('[data-mk-pick]') : [];
      if (picks.length) {
        var by = {};
        picks.forEach(function (p) { by[p.value] = (by[p.value] || 0) + 1; });
        items = Object.keys(by).map(function (id) { return { id: +id, quantity: by[id] }; });
      }
      document.querySelectorAll('[data-mk-add].is-on').forEach(function (x) { items.push({ id: +x.dataset.mkAdd, quantity: 1 }); });
      add(items, cta).then(function () {
        document.querySelectorAll('[data-mk-add].is-on').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', false); });
        render();
      });
    });
    box.addEventListener('click', function (e) {
      var c = e.target.closest('[data-mk-chip]');
      if (!c) return;
      e.preventDefault(); e.stopPropagation();
      var row = c.closest('.mk-picks__row'), sel = row.querySelector('[data-mk-pick]');
      row.querySelectorAll('[data-mk-chip]').forEach(function (x) { x.classList.toggle('is-on', x === c); });
      sel.value = c.dataset.mkChip; sel.__touched = true; render(); checkStock();
    });
    document.addEventListener('variant:update', function (e) {
      var v = e.detail && e.detail.resource;
      if (!v) return;
      if (e.detail.data && e.detail.data.productId && String(e.detail.data.productId) !== box.dataset.productId) return;
      box.dataset.variant = v.id;
      if (v.price != null) price = v.price;
    box.querySelectorAll('[data-mk-pick]').forEach(function (p) { if (p.__touched) return; p.value = String(v.id); p.closest('.mk-picks__row').querySelectorAll('[data-mk-chip]').forEach(function (x) { x.classList.toggle('is-on', x.dataset.mkChip === String(v.id)); }); });
      var off = box.querySelector('[data-mk-cta]');
      if (off) off.disabled = v.available === false;
      render();
    });
    box.querySelectorAll('[data-mk-pick]').forEach(function (p) {
      p.addEventListener('change', function () { p.__touched = true; render(); });
    });
    function checkStock() {
      var sel = box.querySelector('[data-mk-offer].is-selected'), msg = box.querySelector('[data-mk-msg]'), cta = box.querySelector('[data-mk-cta]');
      var by = {}, over = '';
      if (sel) sel.querySelectorAll('.mk-picks__row').forEach(function (r) { var c = r.querySelector('[data-mk-chip].is-on'); if (!c) return; by[c.dataset.mkChip] = (by[c.dataset.mkChip] || 0) + 1; if (by[c.dataset.mkChip] > +c.dataset.stock) over = c.textContent.trim() + ': solo quedan ' + c.dataset.stock; });
      if (msg) msg.hidden = !over; if (over) { if (!msg) { msg = document.createElement('p'); msg.className = 'mk-offers__msg'; msg.setAttribute('data-mk-msg', ''); msg.setAttribute('role', 'alert'); cta.insertAdjacentElement('afterend', msg); } msg.textContent = over + '. Elige otro color para completar.'; msg.hidden = false; }
      if (cta) cta.disabled = !!over;
    }
    offers.forEach(function (o) { var i = o.querySelector('input'); if (i) i.addEventListener('change', checkStock); });
    document.addEventListener('mk:extras', render);
    render();
  }

  /* ---------- Complementos de la ficha (marcar / desmarcar) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mk-add]');
    if (!b) return;
    e.preventDefault();
    var on = !b.classList.contains('is-on');
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-pressed', on);
    document.dispatchEvent(new CustomEvent('mk:extras'));
  });

  /* ---------- Botones de compra repetidos en la página ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mks-cta]');
    if (!b) return;
    e.preventDefault();
    var main = document.querySelector('[data-mk-offers] [data-mk-cta]');
    if (main) return main.click();
    var atc = document.querySelector('product-form-component [type="submit"], form[action*="/cart/add"] [type="submit"]');
    if (atc) return atc.click();
    if (b.dataset.href) window.location.href = b.dataset.href;
  });

  /* ---------- Sugeridos del carrito ---------- */
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-mk-rec-nav]');
    if (nav) {
      e.preventDefault();
      var tr = nav.closest('[data-mk-rec]').querySelector('[data-mk-rec-track]');
      var c = tr.querySelector('.mk-rec__card');
      tr.scrollBy({ left: (+nav.dataset.mkRecNav) * ((c ? c.offsetWidth : 160) + 10), behavior: 'smooth' });
      return;
    }
    var btn = e.target.closest('[data-mk-rec-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest('.mk-rec__card'), sel = card.querySelector('[data-mk-rec-variant]');
    card.classList.add('is-loading');
    var req = card.classList.contains('is-on') && btn.dataset.key
      ? json('cart/change.js', { id: btn.dataset.key, quantity: 0 })
      : json('cart/add.js', { items: [{ id: +(sel ? sel.value : btn.dataset.variant), quantity: 1 }] });
    req.then(function () { return refresh(false); })
      .catch(function () {})
      .finally(function () { card.classList.remove('is-loading'); });
  }, true);

  /* Pestañas de la ficha: al abrir una se cierran las demás */
  function singleOpen(rootEl) {
    (rootEl || document).querySelectorAll('.product-information .accordion').forEach(function (acc, i) {
      var group = 'zh-acc-' + i;
      acc.querySelectorAll('details').forEach(function (d) { d.setAttribute('name', group); });
      if (acc.__zh) return; acc.__zh = true;
      acc.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d.open) return;
        acc.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      }, true);
    });
  }

  /* Barra inferior: abrir carrito y contador */
  document.addEventListener('click', function (e) { if (e.target.closest('[data-zh-open-cart]')) { e.preventDefault(); openDrawer(); } });
  document.addEventListener('cart:update', function (e) {
    var n = e.detail && e.detail.resource && e.detail.resource.item_count;
    if (n == null) return;
    document.querySelectorAll('[data-zh-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
  });

  /* Barra de compra fija: aparece cuando el botón principal sale de la pantalla */
  function stickyAtc() {
    var bar = document.querySelector('[data-zh-satc]'), main = document.querySelector('[data-mk-offers] [data-mk-cta]');
    if (!bar || !main || !('IntersectionObserver' in window) || bar.__zh) return;
    bar.__zh = true; bar.hidden = false;
    new IntersectionObserver(function (es) { es.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); }); }).observe(main);
  }

  /* Botones repetidos: precio, precio anterior y descuento del color elegido */
  function ctaUpdate(v) {
    if (!v || v.price == null) return;
    var cmp = v.compare_at_price || 0, on = cmp > v.price;
    var off = on ? Math.round((cmp - v.price) * 100 / cmp) + '%' : '', save = on ? money(cmp - v.price) : '';
    document.querySelectorAll('[data-zh-cta]').forEach(function (sec) {
      var tl = sec.dataset.tl || '', tn = sec.dataset.tn || '';
      var needs = /[(descuento|precio_antes|ahorro)]/;
      if (!on) { if (needs.test(tl)) tl = sec.dataset.tlp || tl; if (needs.test(tn)) tn = sec.dataset.tnp || tn; }
      function fill(t) { return t.split('[precio]').join(money(v.price)).split('[precio_antes]').join(on ? money(cmp) : '').split('[descuento]').join(off).split('[ahorro]').join(save); }
      var l = sec.querySelector('[data-zh-cta-label]'), n = sec.querySelector('[data-zh-cta-note]');
      if (l) l.textContent = fill(tl);
      if (n) n.textContent = fill(tn);
    });
  }
  document.addEventListener('variant:update', function (e) {
    var v = e.detail && e.detail.resource; ctaUpdate(v);
    var sp = document.querySelector('[data-zh-satc] .zh-satc__price');
    if (sp && v && v.price != null) sp.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
  });

  function scan(rootEl) {
    stickyAtc();
    (rootEl || document).querySelectorAll('[data-mk-offers]').forEach(initOffers);
    singleOpen(rootEl);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
